/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { JobParts } from "./JobParts";
export const JobSplitDetails = core.serialization.object({
    parts: JobParts,
    runInParallel: core.serialization.boolean().optional(),
});
